<template>
  <tk-container class="messages" :status="status" infiniteScroll @loadingMore="initData">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      消息
    </tkui-header>
    <div class="body">
      <tk-flex class="message" middle v-for="(item,index) in messages" :key="index">
        <div class="icon unshrink">
          <tk-image width="50" height="50" src="http://moke-store.oss-cn-beijing.aliyuncs.com/77a4a3f5-f0a3-4852-be76-feead2173c0d.png"></tk-image>
        </div>
        <div class="fill">
          <tk-flex between middle>
            <h2 class="name">{{item.machine.name}}</h2>
            <p class="time">{{item|time}}</p>
          </tk-flex>
          <p class="detail">{{item.runState|warn}}</p>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  import moment from 'moment'
  export default {
    data () {
      return {
        status: false,
        messages: [],
        page: 0,
        perAmount: 20
      }
    },
    computed: {
      user () {
        return this.$store.state.user || {}
      }
    },
    methods: {
      back () {
        this.$back()
      },
      async initData (page, next) {
        this.status = 'loading'
        try {
          if (this.user.role === 'admin') {
            await this.adminInit(page, next)
          } else if (this.user.role === 'dealer') {
            await this.dealerInit(page, next)
          } else {
            await this.clientInit(page, next)
          }
          this.status = !this.messages.length ? 'empty' : false
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      async adminInit (page, next) {
        let message = await this.$tkParse.getList('/classes/status', {
          'params': {
            'where': {
              '$or': [
                {
                  'runState': {
                    '$ne': '00'
                  }
                }
              ]
            },
            'order': '-createdAt',
            'include': 'machine',
            'limit': 20,
            'skip': page * 20
          }
        })
        this.messages = [...this.messages, ...message]
        if (message.length > 20) {
          next('+1')
        } else {
          next('complete')
        }
      },
      async dealerInit (page, next) {
        let message = await this.$tkParse.getList('/classes/status', {
          'params': {
            'where': {
              '$or': [
                {
                  'runState': {
                    '$ne': '00'
                  }
                }
              ],
              'machine': {
                '$inQuery': {
                  'where': {
                    'dealer': this.user.objectId
                  },
                  'className': 'machine'
                }
              }
            },
            'order': '-createdAt',
            'include': 'machine',
            'limit': 20,
            'skip': page * 20
          }
        })
        this.messages = [...this.messages, ...message]
        if (message.length > 20) {
          next('+1')
        } else {
          next('complete')
        }
      },
      async clientInit (page, next) {
        let message = await this.$tkParse.getList('/classes/status', {
          'params': {
            'where': {
              '$or': [
                {
                  'runState': {
                    '$ne': '00'
                  }
                }
              ],
              'machine': {
                '$inQuery': {
                  'where': {
                    'client': this.user.objectId
                  },
                  'className': 'machine'
                }
              }
            },
            'order': '-createdAt',
            'include': 'machine',
            'limit': 20,
            'skip': page * 20
          }
        })
        this.messages = [...this.messages, ...message]
        if (message.length > 20) {
          next('+1')
        } else {
          next('complete')
        }
      }
    },
    filters: {
      time (val) {
        let res = val.updatedAt || val.createdAt
        return moment(res).format('YYYY-MM-DD HH:mm')
      },
      warn (val) {
        let items = {
          'E0': '缺水',
          'E1': '溢水',
          'E2': '测温断路',
          'E3': '温度探头短路'
        }
        let res = items[val] || ''
        return res
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .messages{
    .message{
      background: #ffffff;
      margin-bottom: 4px;
      padding: 15px;
      .icon{
        width: 50px;
        height: 50px;
        margin-right: 15px;
      }
      .time{
        font-size: 14px;
        color: #666666;
        margin-bottom: 0!important;
      }
      .name{
        font-size: 16px;
        color: #333333;
        margin-bottom: 5px;
      }
      .detail{
        font-size: 14px;
        color: #666666;
        margin-bottom: 0!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/message/message.vue